import { initialState, nationalLicenseState } from "./state";

// @store-module
import { Module } from "vuex";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

const profileStore: Module<any, nationalLicenseState> = {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export default profileStore;
